import { compose, lifecycle } from 'recompose';
import { connect } from 'react-redux';
import { omitProps } from '../../../common/helpers/props';
import { withActionByRole } from '../../../common/helpers/actions';
import * as actions from '../actions';
import { getAll } from '../selector';

const servicesProviderBase = compose(
  connect(
    state => ({
      services: getAll(state),
    }),
  ),
  lifecycle({
    componentDidMount() {
      this.props.getServices();
    },
  }),
  omitProps([
    'getServices',
  ]),
);

/**
 * @deprecated Use servicesProviderV2
 */
const servicesProvider = compose(
  withActionByRole(
    'getServices', actions.getShopUserServices, actions.getBarberUserServices, actions.getBrandUserServices,
  ),
  servicesProviderBase,
);

export const servicesProviderV2 = compose(
  withActionByRole(
    'getServices', actions.getShopUserServicesV2, actions.getBarberUserServicesV2, actions.getBrandUserServices,
  ),
  servicesProviderBase,
);

export default servicesProvider;
